// Copyright (c) 2022 Siemens

/**
 * @module js/walkmeService.js
 */

import _appCtxSvc from 'js/appCtxService';

var exports = {};

exports.openWalkMePlayer = function() {
    try {
        WalkMePlayerAPI.toggleMenu();
    } catch (error) {
        exports.loadWalkMe();
        WalkMePlayerAPI.toggleMenu();
    }
}

exports.loadWalkMe = function () {
    //Retrieve params
    var cognitoToken = _appCtxSvc.getCtx('cognitoToken');
    var isLongSession = cognitoToken.idToken.payload["custom:longSession"];
    if (isLongSession !== undefined && isLongSession === "true") {
        //no Walkme program
        return;
    }
    if (!!navigator.platform.match(/iPhone|iPod|iPad|MacIntel/)) {
        console.log("IOs -> IOs detected");
        //no Walkme program
        return;
    }

    var userId = cognitoToken.idToken.payload.sub;
    var tenantKey = cognitoToken.idToken.payload["custom:tenantKey"];
    var groups = cognitoToken.idToken.payload["cognito:groups"]; //An array containig our groups
    var locale = _appCtxSvc.getCtx('locale'); 
    var config = _appCtxSvc.getCtx('oPINAuthenticationConfig');
    var useInternalServer = true;
    if (config.useTelemetryInternalServer !== undefined) {
        useInternalServer = JSON.parse(config.useTelemetryInternalServer);
    }
    if (groups === undefined || !Array.isArray(groups)) {
        window.usergroups = {
            MIDashboardContributor : false,
            MIDashboardTemplateAuthor : false,
            MIDashboardViewer : false,
            MIDataExposition : false,
            MISmartViewEngineer : false,
            MISolutionEngineer : false,
            MPDashboardContributor : false,
            MPDashboardViewer : false,
            MPProjectEngineer : false,
            MPProjectPublisher : false,
            MPRuntimeAccess : false,
            OTDEngineer : false,
            RuntimeRestrictedAccess : false,
            Support : false,
            TenantEngineer : false,
            WidgetCustomization : false,
            WorkCalendarEngineer : false,
        };
    } else {
        window.usergroups = {
            MIDashboardContributor : groups && groups.includes("MIDashboardContributor"),
            MIDashboardTemplateAuthor : groups.includes("MIDashboardTemplateAuthor"),
            MIDashboardViewer : groups.includes("MIDashboardViewer"),
            MIDataExposition : groups.includes("MIDataExposition"),
            MISmartViewEngineer : groups.includes("MISmartViewEngineer"),
            MISolutionEngineer : groups.includes("MISolutionEngineer"),
            MPDashboardContributor : groups.includes("MPDashboardContributor"),
            MPDashboardViewer : groups.includes("MPDashboardViewer"),
            MPProjectEngineer : groups.includes("MPProjectEngineer"),
            MPProjectPublisher : groups.includes("MPProjectPublisher"),
            MPRuntimeAccess : groups.includes("MPRuntimeAccess"),
            OTDEngineer : groups.includes("OTDEngineer"),
            RuntimeRestrictedAccess : groups.includes("RuntimeRestrictedAccess"),
            Support : groups.includes("Support"),
            TenantEngineer : groups.includes("TenantEngineer"),
            WidgetCustomization : groups.includes("WidgetCustomization"),
            WorkCalendarEngineer : groups.includes("WorkCalendarEngineer"),
        };
    }
    window.isAdmin = window.usergroups.TenantEngineer;
    window.userid = userId;
    window.customer = tenantKey;
    window.currentLanguage = locale;
    window.internalUser = !useInternalServer;
    let pathSubstr = window.location.pathname.substring( 0, window.location.pathname.indexOf( '/index.html' ) );
    window.readmeUrl = 'https://' + window.location.hostname + pathSubstr + '/OpcenterIN_forCloud_ReadMe_OSS.HTML';

    var analyticsEnvironment = 'internal';
    var link = "https://cdn.walkme.com/users/3cabc52a9e7c494fb3151e550ad06f70/test/walkme_3cabc52a9e7c494fb3151e550ad06f70_https.js";
    if (useInternalServer === false ) {
        //Production Environment
        link = "https://cdn.walkme.com/users/3cabc52a9e7c494fb3151e550ad06f70/walkme_3cabc52a9e7c494fb3151e550ad06f70_https.js";
        analyticsEnvironment = 'external';
    }
    window.analyticsEnv = analyticsEnvironment;
    
    //Create the JavaScript tag
    (
        function () {
            var walkme = document.createElement("script");
            walkme.type = "text/javascript";
            walkme.async = !0;
            walkme.src = link;
            
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(walkme, s);
            
            window._walkmeConfig = {smartLoad:true};
        }
    )();
}
export default new Proxy(exports, {
    get(target, prop) {
        if (typeof target[prop] === 'function') {
            return new Proxy(target[prop], {
                apply: (target, thisArg, argumentsList) => {
                    console.debug("####walkmeService method call: " + prop, argumentsList)
                    return Reflect.apply(target, thisArg, argumentsList);
                }
            });
        } else {
            return Reflect.get(target, prop);
        }
    }
});